import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const QuadroFuncional = () => {
  const [quadros, setQuadros] = useState([]);
  const [filteredQuadros, setFilteredQuadros] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingQuadro, setEditingQuadro] = useState(null);
  const [formData, setFormData] = useState({
    descricao: '',
    sigla: '',
    faixa: '',
    inicial: '',
    final: '',
    ativo: true
  });

  const siglaOptions = ['A', 'B', 'C', 'D', 'E'];
  const faixaOptions = ['MICRO', 'PEQUENO', 'MÉDIO', 'GRANDE', 'ESPECIAL', 'DISPENSA', 'PML'];

  useEffect(() => {
    const fetchQuadros = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/quadro-funcional`);
        if (!response.ok) {
          throw new Error('Erro ao buscar quadros funcionais');
        }
        const data = await response.json();
        setQuadros(data);
        setFilteredQuadros(data);
      } catch (error) {
        console.error('Erro ao carregar quadros funcionais:', error);
      }
    };

    fetchQuadros();
  }, []);

  useEffect(() => {
    const lower = searchTerm.toLowerCase();
    const filtered = quadros.filter((item) =>
      (item.descricao || '').toLowerCase().includes(lower) ||
      (item.sigla || '').toLowerCase().includes(lower) ||
      (item.faixa || '').toLowerCase().includes(lower)
    );
    setFilteredQuadros(filtered);
  }, [searchTerm, quadros]);

  const handleNew = () => {
    setEditingQuadro(null);
    setFormData({
      descricao: '',
      sigla: '',
      faixa: '',
      inicial: '',
      final: '',
      ativo: true
    });
    setShowForm(true);
  };

  const handleEdit = (quadro) => {
    setEditingQuadro(quadro);
    setFormData({
      descricao: quadro.descricao,
      sigla: quadro.sigla,
      faixa: quadro.faixa,
      inicial: quadro.inicial,
      final: quadro.final,
      ativo: quadro.ativo
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.descricao.trim() || !formData.sigla.trim() || !formData.faixa.trim()) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    const payload = {
      descricao: formData.descricao,
      sigla: formData.sigla,
      faixa: formData.faixa,
      inicial: formData.inicial === '' ? null : parseFloat(formData.inicial),
      final: formData.final === '' ? null : parseFloat(formData.final),
      ativo: formData.ativo
    };

    try {
      if (editingQuadro) {
        const response = await fetch(
          `${API_BASE_URL}/quadro-funcional/${editingQuadro.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar quadro funcional');
        }

        const updated = await response.json();
        setQuadros((prev) =>
          prev.map((item) => (item.id === editingQuadro.id ? updated : item))
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/quadro-funcional`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar quadro funcional');
        }

        const created = await response.json();
        setQuadros((prev) => [...prev, created]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar quadro funcional:', error);
      alert('Erro ao salvar quadro funcional');
    }
  };

  const resetForm = () => {
    setFormData({
      descricao: '',
      sigla: '',
      faixa: '',
      inicial: '',
      final: '',
      ativo: true
    });
    setEditingQuadro(null);
    setShowForm(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este quadro funcional?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/quadro-funcional/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir quadro funcional');
      }

      setQuadros((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Erro ao excluir quadro funcional:', error);
      alert('Erro ao excluir quadro funcional');
    }
  };

  const handleToggleStatus = async (id) => {
    const atual = quadros.find((i) => i.id === id);
    if (!atual) return;

    const atualizado = {
      ...atual,
      ativo: !atual.ativo
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/quadro-funcional/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(atualizado)
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do quadro funcional');
      }

      const saved = await response.json();
      setQuadros((prev) =>
        prev.map((i) => (i.id === id ? saved : i))
      );
    } catch (error) {
      console.error('Erro ao atualizar status do quadro funcional:', error);
      alert('Erro ao atualizar status');
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Quadro Funcional</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingQuadro ? 'Editar Quadro Funcional' : 'Cadastrar Quadro Funcional'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="descricao">Descrição *</label>
                <input
                  type="text"
                  id="descricao"
                  value={formData.descricao}
                  onChange={(e) =>
                    setFormData({ ...formData, descricao: e.target.value })
                  }
                  required
                  placeholder="Descrição do quadro"
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="sigla">Porte *</label>
                <select
                  id="sigla"
                  value={formData.sigla}
                  onChange={(e) =>
                    setFormData({ ...formData, sigla: e.target.value })
                  }
                  required
                >
                  <option value="">Selecione...</option>
                  {siglaOptions.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="faixa">Faixa *</label>
                <select
                  id="faixa"
                  value={formData.faixa}
                  onChange={(e) =>
                    setFormData({ ...formData, faixa: e.target.value })
                  }
                  required
                >
                  <option value="">Selecione...</option>
                  {faixaOptions.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="inicial">Inicial</label>
                <input
                  type="number"
                  step="0.001"
                  id="inicial"
                  value={formData.inicial}
                  onChange={(e) =>
                    setFormData({ ...formData, inicial: e.target.value })
                  }
                  placeholder="0,000"
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="final">Final</label>
                <input
                  type="number"
                  step="0.001"
                  id="final"
                  value={formData.final}
                  onChange={(e) =>
                    setFormData({ ...formData, final: e.target.value })
                  }
                  placeholder="0,000"
                />
              </div>
            </div>
            
            <div className="form-group">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="ativo"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({ ...formData, ativo: e.target.checked })}
                />
                <label htmlFor="ativo">Ativo</label>
              </div>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={resetForm}
              >
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary">
                <FaSave /> {editingQuadro ? 'Atualizar' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Buscar por descrição, porte ou faixa..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredQuadros.length} registro(s) encontrado(s)</span>
            </div>
            <button 
              className="btn-primary"
              onClick={handleNew}
            >
              <FaPlus /> Novo Quadro
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Descrição</th>
                  <th className="col-sigla">Porte</th>
                  <th className="col-sigla">Faixa</th>
                  <th className="col-prazo">Inicial</th>
                  <th className="col-prazo">Final</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredQuadros.map((quadro) => (
                  <tr key={quadro.id}>
                    <td className="col-id">{quadro.id}</td>
                    <td className="col-nome">{quadro.descricao}</td>
                    <td className="col-sigla">
                      <span className="sigla-badge">{quadro.sigla}</span>
                    </td>
                    <td className="col-sigla">{quadro.faixa}</td>
                    <td className="col-prazo">{quadro.inicial}</td>
                    <td className="col-prazo">{quadro.final}</td>
                    <td className="col-status">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={quadro.ativo}
                          onChange={() => handleToggleStatus(quadro.id)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => handleEdit(quadro)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(quadro.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredQuadros.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhum quadro funcional encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo quadro funcional.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuadroFuncional;
